
jQuery(function ($) {
    "use strict";

    function setAppHeight() {
        document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    }

    function handleScrollEffects() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();


        if ($('body').hasClass('page-template')) {
            $('.hm-banner').toggleClass('faded-out', scrollTop > windowHeight);
            $('.site-header').toggleClass('fixed', scrollTop > windowHeight / 2);

            if ($('.site-header').hasClass('fixed')) {
                $(".hm-banner").css("z-index", "1001");
            }
            else {
                $(".hm-banner").css("z-index", "1");
            }
        }
    }

    $(window).on('resize', setAppHeight);
    $(window).on('scroll load', handleScrollEffects);

    $(document).on('click', '.nav-toggle', function () {
        $(this).toggleClass('open');
        $('html').toggleClass('nav-open');
    });

    $(document).on('click', '.main-navigation a, .register-btn a', function () {
        $('html').removeClass('nav-open');
        $('.nav-toggle').removeClass('open');
    });
    new WOW().init();

    $('#play-btn').on('click', function () {
        var video = $('#hm-video').get(0);
        video.controls = true;
        video.muted = false;
        video.play();
        $(this).fadeOut(); // Hide play button on click
    });
    if (document.body.classList.contains("home")) {
        const intro_video = document.querySelector("#intro-video");
        intro_video.onended = function () {
            $(".intro-video").fadeOut();
            $("body").addClass("loaded");
        };
    }

    $('.rs-living-in-imgs').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        cssEase: 'linear',
        pauseOnHover: true,
        appendDots: $('.rs-living-in-foot .rs-living-in-slick-dots'),
    });

    $('.rs-appointed-in-imgs').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        cssEase: 'linear',
        pauseOnHover: true,
        appendDots: $('.rs-appointed-in-foot .rs-appointed-in-slick-dots'),
    });

    let $slider = $('.lo-imgslider-cl');

    $slider.slick({
        dots: false,
        arrows: true,
        prevArrow: $('.lo-imgslider-cl-arrow .slick-prev'),
        nextArrow: $('.lo-imgslider-cl-arrow .slick-next'),
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    function updateArrows() {
        $('.slick-prev, .slick-next').removeClass('inactive');

        if ($slider.slick('slickCurrentSlide') === 0) {
            $('.slick-prev').addClass('inactive');
        }
        if ($slider.slick('slickCurrentSlide') === $slider.find('.slick-slide').length - 1) {
            $('.slick-next').addClass('inactive');
        }
    }

    updateArrows();  // Initial check
    $slider.on('afterChange', updateArrows);

    $('.video-popup').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                '</div>',
            patterns: {
                vimeo: {
                    index: 'vimeo.com/',
                    id: function (url) {
                        var match = url.match(/vimeo\.com\/(\d+)/);
                        return match ? match[1] : null;
                    },
                    src: 'https://player.vimeo.com/video/%id%?autoplay=1'
                }
            },
            srcAction: 'iframe_src',
        }
    });
});